export enum OrderExclusionContants {
  GET_ORDER_EXCLUSIONS_REQUEST = 'GET_ORDER_EXCLUSIONS_REQUEST',
  GET_ORDER_EXCLUSIONS_SUCCESS = 'GET_ORDER_EXCLUSIONS_SUCCESS',
  GET_ORDER_EXCLUSIONS_FAILURE = 'GET_ORDER_EXCLUSIONS_FAILURE',

  CREATE_ORDER_EXCLUSION_REQUEST = 'CREATE_ORDER_EXCLUSION_REQUEST',
  CREATE_ORDER_EXCLUSION_SUCCESS = 'CREATE_ORDER_EXCLUSION_SUCCESS',
  CREATE_ORDER_EXCLUSION_FAILURE = 'CREATE_ORDER_EXCLUSION_FAILURE',

  UPDATE_ORDER_EXCLUSION_REQUEST = 'UPDATE_ORDER_EXCLUSION_REQUEST',
  UPDATE_ORDER_EXCLUSION_SUCCESS = 'UPDATE_ORDER_EXCLUSION_SUCCESS',
  UPDATE_ORDER_EXCLUSION_FAILURE = 'UPDATE_ORDER_EXCLUSION_FAILURE',

  DELETE_ORDER_EXCLUSION_REQUEST = 'DELETE_ORDER_EXCLUSION_REQUEST',
  DELETE_ORDER_EXCLUSION_SUCCESS = 'DELETE_ORDER_EXCLUSION_SUCCESS',
  DELETE_ORDER_EXCLUSION_FAILURE = 'DELETE_ORDER_EXCLUSION_FAILURE',
}
